{
  "el": {
    "task_assignment": {
      "actions": {
        "confirm": "Σήμανση ως ολοκληρωμένη",
        "create": "Εργασία",
        "reopen": "Άνοιγμα ξανά",
        "update": "Επεξεργασία εργασίας"
      },
      "assignee_types": {
        "customer": "Πελάτης",
        "employee": "Υπάλληλος",
        "partner": "Συνεργάτης"
      },
      "attributes": {
        "assignee": "Υπεύθυνος",
        "assignees": "Υπεύθυνοι",
        "created_at": "Δημιουργήθηκε",
        "due_date": "Προθεσμία",
        "project": "Έργο",
        "published": "Δημοσιευμένο",
        "status": "Κατάσταση",
        "task": "Εργασία",
        "unit": "Ακίνητο"
      },
      "labels": {
        "add_assignee": "Προσθήκη υπευθύνου…",
        "add_customers": "Προσθήκη πελατών",
        "already_assigned": "Αυτή η εργασία έχει ήδη προστεθεί σε αυτό το ακίνητο.",
        "completed": "Ολοκληρωμένη",
        "confirm_message": "Θέλεις σίγουρα να σημειώσεις αυτή την εργασία ως ολοκληρωμένη;",
        "customers": "Πελάτες",
        "my_tasks": "Οι εργασίες μου",
        "no_assignees": "Χωρίς υπευθύνους ακόμη.",
        "no_assignments": "Δεν υπάρχουν ακόμη εργασίες.",
        "no_assignments_task": "Δεν υπάρχουν ακόμη αναθέσεις για αυτή την εργασία.",
        "no_assignments_unit": "Δεν υπάρχουν ακόμη εργασίες για αυτό το ακίνητο.",
        "publish_all": "Δημοσίευση όλων",
        "publish_customers": "Δημοσίευση για τους πελάτες κάθε ακινήτου",
        "published": "Δημοσιευμένο",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "select_task": "Επίλεξε μια εργασία",
        "upload_hint": "Ανέβασε τα ζητούμενα έγγραφα για να ολοκληρώσεις αυτή την εργασία.",
        "uploaded_documents": "Ανεβασμένα έγγραφα"
      },
      "statuses": {
        "completed": "Ολοκληρωμένη",
        "draft": "Πρόχειρη",
        "pending": "Εκκρεμής"
      },
      "toasts": {
        "completed": "Η εργασία ολοκληρώθηκε",
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "uncompleted": "Η εργασία άνοιξε ξανά",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
